/** Returns an HSL triplet for button hover: explicit override, or a lighter (darker if very light) primary. */
export function getHoverColour(primary: string, override?: string): string {
  if (override && override.trim()) return override;
  const m = primary.match(/^\s*([\d.]+)\s+([\d.]+)%\s+([\d.]+)%\s*$/);
  if (!m) return primary;
  const l = Number(m[3]);
  const next = l > 85 ? l - 10 : Math.min(100, l + 10);
  return `${m[1]} ${m[2]}% ${next}%`;
}
